module.exports = __webpack_public_path__ + "static/media/sports_2.3e3a67c8.jpg";